import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { TextTitle, getPanelErrorProps, ValidatedPanel } from '@bingads-webui-campaign/wizard-jumbo-card';
import { ValidatedAdRotation } from './validated-ad-rotation';
import adRotationIcon from './ad-rotation.svg';
import { ROTATION_OPTION_TO_TEXT } from './constants';

export const AdRotationSection = ({ data, disableOptions, ...rest }) => {
  const i18n = useContext(I18nContext);

  return (
    <ValidatedPanel
      key="ad-rotation"
      title={
        <TextTitle
          titleKey={_TL_('Ad rotation')}
          details={data && ROTATION_OPTION_TO_TEXT[data.AdRotation]}
          icon={adRotationIcon}
          iconStyles={{ width: 20 }}
          topicKey="Page_Campaign_AdRotation"
        />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      {...rest}
    >
      <span className="ad-rotation-descriptions">
        {i18n.getString(_TL_('Which ads do you want to show?'))}
      </span>
      {
        data &&
        <ValidatedAdRotation
          field="AdRotation"
          value={data.AdRotation}
          disableOptions={disableOptions}
        />
      }
    </ValidatedPanel>
  );
};

AdRotationSection.propTypes = {
  data: PropTypes.shape({
    AdRotation: PropTypes.string,
  }).isRequired,
  disableOptions: PropTypes.bool,
};

AdRotationSection.defaultProps = {
  disableOptions: false,
};
